import React from 'react';
import { Img } from 'glamorous';
import PropTypes from 'prop-types'
import styles from "../../../styles";
import mediaQueries from "../../../styles/media-queries";
import bottleBackgrounds from "../../../imgs/bottles/backgrounds";
import Item from './Item';

const e = styles.editor;

const imageStyles = {
  width: "240px",
  height: "auto",
  [mediaQueries.tablet]: {
      width: "170px"
  }
};

const TemplateOption = props => (
  <Item onClick={() => props.handleClick()}>
    <Img css={imageStyles} src={bottleBackgrounds.frame} />
    <Img
      css={{
        ...e.selectOption,
        outline: props.isSelected ? "3px solid white" : ""
      }}
      src={props.template.preview}
    />
  </Item>
);

TemplateOption.propTypes = {
  isSelected: PropTypes.bool,
  image: PropTypes.string,
  handleClick: PropTypes.func
};

export default TemplateOption;



// WEBPACK FOOTER //
// ./src/components/areas/Background/TemplateOption.js